module.exports = __webpack_public_path__ + "img/home-largest-company.395e5ea2.png";